import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IResponse } from '@interfaces/i-response';
import { ICarnivitaConfigurations, ICarnivitaPatientData } from '@models/carnivita-pms/carnivita-pms';
import { Observable } from 'rxjs';
import { SuccessResponse } from '@models/home/response.model';



@Injectable({
  providedIn: 'root'
})
export class CarnivitaPmsService {

  carnivitaPatientData: ICarnivitaPatientData = {} as ICarnivitaPatientData

  getCarnivitaConfigurationsUrl: string = 'api/PortalCarnivitaConfigurations/GetCarnivitaConfigurations'
  getCarnivitaPatientUrl: string = 'api/PortalCarnivitaPatients/GetCarnivitaPatient'
  addCarnivitaMalePatientUrl: string = 'api/PortalCarnivitaPatients/AddCarnivitaMalePatient'
  addCarnivitaFemalePatientUrl: string = 'api/PortalCarnivitaPatients/AddCarnivitaFemalePatient'

  constructor(private http: HttpClient) { }

  getCarnivitaConfigurations(): Observable<IResponse<ICarnivitaConfigurations>> {
    return this.http.get<IResponse<ICarnivitaConfigurations>>(this.getCarnivitaConfigurationsUrl)
  }

  getCarnivitaPatient(phoneNumber: string): Observable<IResponse<ICarnivitaPatientData>> {
    return this.http.get<IResponse<ICarnivitaPatientData>>(`${this.getCarnivitaPatientUrl}?phone=${phoneNumber}`)
  }

  addCarnivitaMalePatient(malePatientData: FormData):Observable<SuccessResponse>{
    return this.http.post<SuccessResponse>(this.addCarnivitaMalePatientUrl, malePatientData)
  }
  
  addCarnivitaFemalePatient(femalePatientData: FormData):Observable<SuccessResponse>{
    return this.http.post<SuccessResponse>(this.addCarnivitaFemalePatientUrl, femalePatientData)
}

}
